module.exports = __webpack_public_path__ + "media/correctAnwer.cb6f490f.mp3";